module.exports = __webpack_public_path__ + "img/ic-shopeepay.ffd82504.png";